import { render, staticRenderFns } from "./xianyu.vue?vue&type=template&id=0a7ed9cd&scoped=true"
import script from "./xianyu.vue?vue&type=script&lang=js"
export * from "./xianyu.vue?vue&type=script&lang=js"
import style0 from "./xianyu.vue?vue&type=style&index=0&id=0a7ed9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_66tmnsjmdpdsiqf6am2qinky4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ed9cd",
  null
  
)

export default component.exports